import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

/* Layout */
import Layout from '@/layout/index.vue';

/* Router modules */

import qualificationManagement from './modules/ModuleQualificationManagement';
import personalWorkstation from './modules/ModulePersonalWorkstation';
import merchantManagement from './modules/ModuleMerchantManagement';
import systemRoutes from './modules/ModuleSystem';
import merchantCertificateManagement from './modules/ModuleMerchantCertificateManagement';
import paymentVerification from './modules/ModulePaymentVerification';
import changeManagement from './modules/ModuleChangeManagement';
import profileMaintain from './modules/ModuleProfileMaintain';
import authorizationLetter from './modules/ModuleAuthorizationLetterManagement';

/** 解决vue-router push 重复点击路由会报错：Avoided redundant navigation to current location 的问题 */
const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
	return originalPush.call(this, location)['catch']((err: any) => err);
};

Vue.use(VueRouter);

/*
  Note: sub-menu only appear when children.length>=1
  Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
*/

/*
  name:'router-name'             the name field is required when using <keep-alive>, it should also match its component's name property
                                 detail see : https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    roles: ['admin', 'editor']   will control the page roles (allow setting multiple roles)
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    hidden: true                 if true, this route will not show in the sidebar (default is false)
    alwaysShow: true             if true, will always show the root menu (default is false)
                                 if false, hide the root menu when has less or equal than one children route
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    noCache: true                if true, the page will not be cached (default is false)
    affix: true                  if true, the tag will affix in the tags-view
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
*/

/**
  ConstantRoutes
  a base page that does not have permission requirements
  all roles can be accessed
*/
export const constantRoutes: RouteConfig[] = [
	{
		path: '/redirect',
		component: Layout,
		meta: { hidden: true },
		children: [
			{
				path: '/redirect/:path(.*)',
				component: (): any => import(/* webpackChunkName: "redirect" */ '@/views/redirect/index.vue')
			}
		]
	},
	{
		path: '/login',
		component: (): any => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
		meta: { hidden: true }
	},
	{
		// 403
		path: '/403',
		name: 'errorPage',
		component: (): any => import(/*  webpackChunkName: "secondHomePage" */ '@/views/index/error-home-page/index.vue')
	},
	{
		path: '/',
		component: Layout,
		redirect: '/home/homePage'
	},
	{
		path: '/home',
		name: 'home',
		component: Layout,
		redirect: '/home/homePage',
		children: [
			// {
			// 	path: 'index',
			// 	component: (): any => import(/* webpackChunkName: "guide" */ '@/views/index/first-home-page/FirstHomePage.vue'),
			// 	name: 'index',
			// 	meta: {
			// 		title: 'dashboard',
			// 		noCache: true
			// 	}
			// },
			{
				// 二级首页
				name: 'secondHomePage',
				path: 'homePage',
				component: (): any => import(/*  webpackChunkName: "secondHomePage" */ '@/views/index/second-home-page/SecondHomePage.vue'),
				meta: {
					title: 'dashboard',
					code: 'Home'
				}
			}
		]
	},
	{
		path: '/details',
		name: 'details',
		component: (): any => import(/*  webpackChunkName: "secondHomePage" */ '@/views/index/details/index.vue'),
		meta: {
			title: 'details',
			hidden: true
		}
	}
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes: RouteConfig[] = [
	// 业务路由
	// personalWorkstation,
	// merchantManagement,
	// paymentVerification,
	// merchantCertificateManagement,
	// qualificationManagement,
	// changeManagement,
	// authorizationLetter,
	// systemRoutes,
	// profileMaintain
];

/** create router */
const createRouter: any = (): any =>
	new VueRouter({
		// mode: 'history',
		scrollBehavior: (to: any, from: any, savedPosition: any): any => {
			if (savedPosition) {
				return savedPosition;
			}

			return { x: 0, y: 0 };
		},
		base: process.env.VUE_APP_ENV_PERFIX,
		routes: constantRoutes
	});

/** router */
const router: any = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
/** reset router */
export function resetRouter(): any {
	const newRouter: any = createRouter();

	// reset router
	router.matcher = newRouter.matcher;
}

export default router;
